module.exports = __webpack_public_path__ + "img/eventi_logo.87d36d83.png";